import jwtDecode from 'jwt-decode'
import { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import LiveContext from '../../components/Context/LiveContext'
import { autoLogin } from '../../utils/Utils'

export default function InvitationRequest() {
  const { t } = useTranslation('invitationError')
  const { setIdWatcher } = useContext(LiveContext)

  const navigate = useNavigate()

  const { requestId } = useParams()

  const [searchParams] = useSearchParams()
  const challenge = searchParams.get('challenge')
  const email = searchParams.get('email')

  const { toggleLivePreview, toggleLivePreviewMinimized } =
    useContext(LiveContext)

  useEffect(() => {
    autoLogin(challenge, email)
      .then(() => {
        localStorage.setItem('idRequest', requestId)
        setIdWatcher(jwtDecode(localStorage.getItem('access_token')).sub)
        navigate('/account/demand')
        toggleLivePreview(true)
        toggleLivePreviewMinimized(false)
      })
      .catch(() => {
        toast.error(t('error'))
        navigate('/')
      })
  }, [email, challenge])

  return null
}
